module.exports = __webpack_public_path__ + "static/media/OPS-NEW.94827b2f.apng";